import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ReviseBooking.html?raw';
import on from 'dojo/on';
import WizardView from '../../../moreCore/UI/Wizard/WizardView';
import "../../../moreCore/UI/Wizard/WizardView";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import "../../../moreCore/UI/Edit/Edit";
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import TiReviseBookingForm from '../../TransportIntermodal/ReviseBookingForm';
import "../../TransportIntermodal/ReviseBookingForm";

class TiBookingRevisionWizard extends compose(_WidgetBaseSP) {
    templateString: any = template;

    wizardContainer: HTMLElement;
    debugContainer: HTMLElement;

    navRow: HTMLElement;
    nav1: HTMLElement;
    nav2: HTMLElement;
    nav3: HTMLElement;
    nav4: HTMLElement;

    nav1Summary: HTMLElement;
    nav2Summary: HTMLElement;
    nav3Summary: HTMLElement;
    nav4Summary: HTMLElement;

    nav1Container: HTMLElement;
    nav2Container: HTMLElement;
    nav3Container: HTMLElement;
    nav4Container: HTMLElement;

    sectionWizardFinished: HTMLElement;

    btnReturnToList: HTMLButtonElement;
    btnAnotherBooking: HTMLButtonElement;



    reviseForm: MdsLax<InstanceType<typeof TiReviseBookingForm>>;

    wizard: MdsLax<InstanceType<typeof WizardView>>;

    private setupWizard(): void {
        let wizard = new WizardView();
        this.wizard = wizard;

        wizard.placeAt(this.wizardContainer, "first");

        on(wizard, "change", lang.hitch(this, this._onWizardEvent));
        on(wizard, "pageswitch", lang.hitch(this, this._onWizardEvent));

        this.reviseForm = new TiReviseBookingForm();
        this.reviseForm.placeAt(this.debugContainer);
        on(this.reviseForm, "revisionCompleted", lang.hitch(this, this._onCompletedRevision));

        wizard.setupNavigation(false, "none", "none");
        //wizard.setupNavigation(true, true, true);
        ////wizard.setupFinishEvent( lang.hitch(this, this._on))

        let index = -1;
        index = wizard.addPage(this.reviseForm, this.reviseForm.section1_bookingFilter, "changeStep1", "s1_bookingFilter_Valid", "s1_bookingFilter_Summary", "DIVISON & ROUTE SECTION");

        index = wizard.addPage(this.reviseForm, this.reviseForm.section2_bookedSlotSelect, "changeStep2", "s2_bookedSlotSelect_Valid", "s2_bookedSlotSelect_Summary", "CHOOSE BOOKED SECTION SLOT");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.reviseForm, this.reviseForm.section3_newRouteSectionSelect, "changeStep3", "s3_newTimeslotSelect_Valid", "s3_newTimeslotSelect_Summary", "SELECT ALTERNATE ROUTE SLOT");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.reviseForm, this.reviseForm.section4_Summary, "revisionCompleted", "revisionCompleted", "s3_newTimeslotSelect_Summary", "SUMMARY");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");

        index = wizard.addPage(this.reviseForm, this.reviseForm.section5_RevisionComplete, null, null, null, "COMPLETED");
        wizard.addPageRule(index, "switchToIfPreviousIsValid");


    }

    private _onCompletedRevision() {
        this.sectionWizardFinished.scrollIntoView({ behavior: "smooth" });
    }

    _onWizardEvent(data: Wizard.WizardPageEntry) {
        let summary = this.wizard.getPageSummary(data.index);
        //console.debug("_onWizardEvent", data, summary);

        let navTarget = null;
        let target: HTMLElement = null;

        let currentPage = this.wizard.getCurrentSelectedPageIndex();

        switch (data.index) {
            case 0:
                target = this.nav1Summary;
                navTarget = this.nav1;
                break;

            case 1:
                target = this.nav2Summary;
                navTarget = this.nav2;
                break;

            case 2:
                target = this.nav3Summary;
                navTarget = this.nav3;
                break;

            case 3:
                target = this.nav4Summary;
                navTarget = this.nav4;
                break;
        }

        if (navTarget) {
            this.UiModder.domClass.remove(navTarget, "hoverDark");
        }

        let validPages = this.wizard.getValidPages(true);
        //validPages.sort() // TODO
        this.UiModder.domClass.toggle(this.nav1, "enabled", true);
        this.UiModder.domClass.toggle(this.nav2, "enabled", validPages.indexOf(0) != -1);
        this.UiModder.domClass.toggle(this.nav3, "enabled", validPages.indexOf(0) != -1 && validPages.indexOf(1) != -1 );
        this.UiModder.domClass.toggle(this.nav4, "enabled", validPages.indexOf(0) != -1 && validPages.indexOf(1) != -1 && validPages.indexOf(2) != -1);

        this.UiModder.domClass.toggle(this.nav1, "hoverDark", currentPage != 0);
        this.UiModder.domClass.toggle(this.nav2, "hoverDark", currentPage != 1);
        this.UiModder.domClass.toggle(this.nav3, "hoverDark", currentPage != 2);
        this.UiModder.domClass.toggle(this.nav4, "hoverDark", currentPage != 3);

        this.UiModder.domClass.toggle(this.nav1, "selected", currentPage == 0);
        this.UiModder.domClass.toggle(this.nav2, "selected", currentPage == 1);
        this.UiModder.domClass.toggle(this.nav3, "selected", currentPage == 2);
        this.UiModder.domClass.toggle(this.nav4, "selected", currentPage == 3);

        if (target) {
            this.UiModder.domAttr.set(target, "innerHTML", summary);
        }

        // Navigation einblenden, wenn die erste Seite mit der Vorauswahl fertig ist:
        if (validPages.indexOf(0) != -1) {
            this.UiModder.domClass.remove(this.navRow, "w3-hide");
        } else {
            // ansonsten immer zurück zu Seite 1
            this.switchToPage(0);
        }

        // Navigation ausblenden, wenn Seite 4 (Buchung abgeschickt) fertig ist wird
        if (validPages.indexOf(3) != -1) {
            this.UiModder.domClass.add(this.navRow, "w3-hide");
            this.UiModder.domClass.toggle(this.sectionWizardFinished, "w3-hide", false);

        }


        if (validPages.length == 5) {
            this._data = this.reviseForm.getData();
            
        } else {
            this._data = null;
        }

    }

    private _data: any = null;

    
    private switchToPage(target: number) {
        if (this.wizard.getCurrentSelectedPageIndex() == target) {
            if (this.wizard.getValidPages().length == 4) {
                target = 3; // zur Buchungszusammenfassung zurück
            } else {
                target = 0;
            }
        }

        if (this.wizard.getPageSelectable(target)) {
            this.wizard.switchToPage(target);
        }
    }

    private _onClick_Nav1(evt: MouseEvent) {
        this.switchToPage(0);
    }

    private _onClick_Nav2(evt: MouseEvent) {
        this.switchToPage(1);
    }
    private _onClick_Nav3(evt: MouseEvent) {
        this.switchToPage(2);
    }
    private _onClick_Nav4(evt: MouseEvent) {
        this.switchToPage(3);
    }

    private _onClick_AnotherBooking(evt: MouseEvent) {
        location.reload();
    }

    private _onClick_ReturnToList(evt: MouseEvent) {
        location.href = window.appRoot + "TransportIntermodal/List";

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setupWizard();
    }
}

export default mdsWidget(TiBookingRevisionWizard);